<script>
  let year = new Date().getFullYear();
</script>

<footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>American Red Cross</strong>
      &copy;{year}. All rights reserved.
    </p>
  </div>
</footer>
